import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'utils/scroll-info-view'

import { EventSourcePolyfill } from 'event-source-polyfill'

// fix for IE11 localStorage not synchronised across tabs
window.onstorage = function () {}
window.EventSource = window.EventSource || EventSourcePolyfill
